import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/mock';

export const Footer = () => {
  const { language } = useLanguage();
  const t = translations[language];
  const navigate = useNavigate();

  return (
    <footer className="py-8 px-4 sm:px-6 lg:px-8 bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto text-center space-y-4">
        {/* Text section with brown background */}
        <div className="bg-brown-900 py-4 px-6 rounded-lg">
          <p className="text-white mb-2 text-[15px]">{t.footer.description}</p>
          <p className="text-white text-[13px]">{t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
};